import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { FastDelivery, PickupStore, ExpressDelivery, Delivery1h, DeliveryRTomorrow, Delivery24h, Airplane } from '@magalu/stereo-ui-icons';
import { getPaletteColor, themeGet, color } from '@magalu/stereo-ui-styles';
import { Flex } from '../../atoms';
import Text from '../../atoms/Text';
const deliveryIconDefault = css`
  margin-right: 12px;
  flex-grow: 0;
  width: 30px;
  height: 30px;
`;
export const Container = styled(Flex)`
  padding: 16px 12px;
  align-items: center;
`;
export const FastDeliveryIcon = styled(FastDelivery)`
  ${deliveryIconDefault}
  ${color}
`;
export const PickupStoreIcon = styled(PickupStore)`
  ${deliveryIconDefault}
  ${color}
`;
export const Delivery1hIcon = styled(Delivery1h)`
  ${deliveryIconDefault}
  ${color}
`;
export const DeliveryRTomorrowIcon = styled(DeliveryRTomorrow)`
  ${deliveryIconDefault}
  ${color}
`;
export const Delivery24hIcon = styled(Delivery24h)`
  ${deliveryIconDefault}
  ${color}
`;
export const ExpressDeliveryIcon = styled(ExpressDelivery)`
  ${deliveryIconDefault}
  ${color}
  min-width: 30px;
`;
export const AirPlaneIcon = styled(Airplane)`
  ${deliveryIconDefault}
  ${color}
  min-width: 30px;
`;
export const Description = styled(Text)`
  flex: 4;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  line-height: ${props => themeGet('lineHeights.big')(props)};
`;
export const Complement = styled(Text)`
  display: block;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  padding-right: 15px;
`;
export const Price = styled(Text)`
  flex: 1;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  text-align: center;
  color: ${_ref => {
  let {
    free
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["free"]);

  return free ? getPaletteColor('secondary.base')(props) : getPaletteColor('text.base')(props);
}};
  display: contents;
`;